import { node, dom } from 'jsx-pragmatic'

const style = `
  .mbo-cdc-loader {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .ui-spinner {
    animation: spin 1s linear infinite;
    height: 32px;
    width: 32px;
  }
  
  .ui-spinner .ui-spinner--bg {
    stroke: #E4F4F8;
    stroke-width: 3.5;
  }
  
  .ui-spinner .ui-spinner--dash {
    stroke: #78C4D8;
    stroke-width: 3.5;
    stroke-linecap: round;
    stroke-dashoffset: -35;
    stroke-dasharray: 90, 150;
  }
`

const bannerLoader = ({ doc }) => {
  return node(
    'html',
    {},
    node('head', {}, node('style', {}, style)),
    node(
      'body',
      {},
      node(
        'div',
        { class: 'mbo-cdc-loader' },
        node(
          'svg',
          {
            class: 'ui-spinner',
            xmlns: 'http://www.w3.org/2000/svg',
            fill: 'none',
            viewBox: '0 0 24 24',
          },
          node('circle', {
            class: 'ui-spinner--bg',
            cx: '12',
            cy: '12',
            r: '10',
          }),
          node('circle', {
            class: 'ui-spinner--dash',
            cx: '12',
            cy: '12',
            r: '10',
          }),
        ),
      ),
    ),
  ).render(dom({ doc }))
}

export default bannerLoader
